export function createFomoDecision({
  root: landing,
  isPaused,
  isReduced,
  requestUpdate,
  listen,
  animate,
}) {
  const root = landing.querySelector(".decision-section");
  const tabs = [...root.querySelectorAll("[data-decision]")];
  const panels = [...root.querySelectorAll("[data-decision-panel]")];
  let current = 0,
    entrance = null;
  function select(index, focus = false) {
    if (current === index) {
      if (focus) tabs[index].focus();
      return;
    }
    current = index;
    tabs.forEach((tab, i) => {
      tab.setAttribute("aria-selected", String(i === index));
      tab.tabIndex = i === index ? 0 : -1;
    });
    panels.forEach((panel, i) => {
      panel.hidden = i !== index;
      panel.classList.toggle("is-active", i === index);
    });
    root.querySelector("#decision-index").textContent = String(
      index + 1
    ).padStart(2, "0");
    root.querySelector(".decision-foot").hidden = index !== 0;
    entrance?.cancel();
    if (!isPaused() && !isReduced())
      entrance = animate(
        panels[index],
        [
          {
            opacity: 0,
            transform: "translateY(22px)",
          },
          {
            opacity: 1,
            transform: "translateY(0)",
          },
        ],
        {
          duration: 480,
          easing: "cubic-bezier(.16,1,.3,1)",
        }
      );
    if (focus) tabs[index].focus();
    requestUpdate();
  }
  tabs.forEach((tab, i) => {
    listen(tab, "click", () => select(i));
    listen(tab, "keydown", (e) => {
      let next;
      if (e.key === "ArrowRight") next = (i + 1) % 3;
      else if (e.key === "ArrowLeft") next = (i + 2) % 3;
      else if (e.key === "Home") next = 0;
      else if (e.key === "End") next = 2;
      else return;
      e.preventDefault();
      select(next, true);
    });
  });
  const steps = [
    [
      "fas fa-ticket-alt",
      "Elige tu entrada",
      "Encuentra tu zona, mesa o asiento.",
    ],
    [
      "fas fa-credit-card",
      "Paga desde el celular",
      "Completa la compra de tu entrada.",
    ],
    ["fas fa-qrcode", "Tu entrada, lista", "Lleva tu QR el día del evento."],
  ];
  root.querySelectorAll("[data-speed-step]").forEach((button) =>
    listen(button, "click", () => {
      const index = Number(button.dataset.speedStep),
        data = steps[index];
      root
        .querySelectorAll("[data-speed-step]")
        .forEach((b) => b.setAttribute("aria-pressed", String(b === button)));
      root.querySelector("#speed-result-icon i").className = data[0];
      root.querySelector("#speed-result-title").textContent = data[1];
      root.querySelector("#speed-result-copy").textContent = data[2];
      const result = root.querySelector(".speed-result");
      result.dataset.step = String(index);
      if (!isPaused() && !isReduced())
        animate(
          result,
          [
            {
              opacity: 0.3,
              transform: "translateY(7px)",
            },
            {
              opacity: 1,
              transform: "translateY(0)",
            },
          ],
          {
            duration: 300,
            easing: "ease-out",
          }
        );
    })
  );
  return {
    update(progress) {
      const value = isPaused() || isReduced() ? 1 : Number(progress);
      root.style.setProperty("--decision-progress", String(value));
      root.querySelectorAll(".calendar-days>div").forEach((day, index) => {
        const phase = Math.max(0, Math.min(1, value * 1.6 - index * 0.22));
        day.style.setProperty(
          "--money-day",
          (phase * phase * (3 - 2 * phase)).toFixed(3)
        );
      });
      if (isPaused() || isReduced()) entrance?.finish();
    },
  };
}
